import type { AssetStoryblok } from "~/generated/sb/blok-types";

export const getStoryblokFile = (media: Partial<AssetStoryblok>) => {
	const file = media.filename;
	return file;
};

export const getStoryblokAlt = (media: Partial<AssetStoryblok>) => {
	const alt = media.alt;
	return alt ?? "";
};

const getStoryblokSize = (media: Partial<AssetStoryblok>) => {
	const regex = /\d+x\d+/;
	const size = getStoryblokFile(media)?.match(regex)?.[0];

	return size;
};

export const getStoryblokWidth = (media: Partial<AssetStoryblok>) => {
	const width = getStoryblokSize(media)?.split("x")[0];
	return width;
};

export const getStoryblokHeight = (media: Partial<AssetStoryblok>) => {
	const height = getStoryblokSize(media)?.split("x")[1];
	return height;
};

// result should be passed down directly to style={{objectPosition: values}} on next/image
export const getStoryblokFocus = (media: Partial<AssetStoryblok>) => {
	const focus = media?.focus;

	if (!focus) return "center";

	const width = getStoryblokWidth(media);
	const height = getStoryblokHeight(media);

	const xInt = Number.parseInt(focus?.split(":")[0]?.split("x")[0] ?? "0", 10);
	const yInt = Number.parseInt(focus?.split(":")[0]?.split("x")[1] ?? "0", 10);

	const x = Math.round((xInt / Number.parseInt(width ?? "1", 10)) * 100);
	const y = Math.round((yInt / Number.parseInt(height ?? "1", 10)) * 100);

	return `${x}% ${y}%`;
};
